import { DOCS_URL } from "../../../config/constants.js";
import ServiceGrid from "./ServiceGrid.svelte";

export default {
    component: ServiceGrid,
    name: "Service Grid",
    description: "Grid layout for displaying multiple services",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/molecules-servicegrid--docs`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/grid-pattern.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2Ff7b37745b6e143d49dfeb1287abeb74e",
    inputs: [
        {
            friendlyName: "Services",
            name: "services",
            type: "list",
            subFields: [
                {
                    friendlyName: "Heading",
                    name: "servicesHeading",
                    type: "string",
                },
                {
                    friendlyName: "CTA Text",
                    name: "ctaText",
                    type: "string",
                    defaultValue: "Get in touch",
                },
                {
                    friendlyName: "CTA Link (use `#contact` to open contact form)",
                    name: "contactEmailAddress",
                    type: "string",
                    defaultValue: "#contact",
                },
                {
                    friendlyName: "Services List",
                    name: "servicesList",
                    type: "list",
                    subFields: [
                        {
                            friendlyName: "Title",
                            name: "title",
                            type: "string",
                        },
                        {
                            friendlyName: "Description",
                            name: "description",
                            type: "longText",
                        },
                        {
                            friendlyName: "Sub Services",
                            name: "subServices",
                            type: "longText",
                        },
                    ],
                },
            ],
        },
    ],
};
